/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Loader, Text, Button } from '@mantine/core';
import { i18n } from '@lingui/core';
import { closeAllModals, openModal } from '@mantine/modals';
import { FC, useState } from 'react';
import { ContractTemplateS } from '../../../Service/ContractTemplateS';
import { ContractS } from '../../../Service/ContractS';

interface DeleteModalProps {
  contractId?: number;
  blockId: number;
  templateName: string;
  onFinish: () => void;
}

// eslint-disable-next-line import/prefer-default-export
export const openDeleteContractTemplateBlockModal = (props: DeleteModalProps) => {
  openModal({
    title: (
      <Text weight="bolder" size="xl">
        {i18n._('textBlocks.delete.confirm.head')}
      </Text>
    ),
    children: <DeleteContractTemplateBlockModal {...props} />,
  });
};

const DeleteContractTemplateBlockModal: FC<DeleteModalProps> = ({ contractId, blockId, templateName, onFinish }) => {
  const [loading, setLoading] = useState(false);

  const onConfirm = async () => {
    setLoading(true);
    let resJSON;
    if (contractId) {
      resJSON = await ContractS.removeTextBlock(blockId, contractId);
    } else {
      resJSON = await ContractTemplateS.removeTextBlock(templateName, blockId);
    }
    setLoading(false);
    if (resJSON) {
      onFinish();
      closeAllModals();
    }
  };

  return (
    <>
      <Text>{i18n._('textBlocks.delete.confirm')}</Text>
      <Group position="right" spacing="xs" mt="xl">
        <Button variant="default" onClick={() => closeAllModals()}>
          {i18n._('actions.cancel')}
        </Button>
        <Button rightIcon={loading && <Loader size="xs" />} color="red" disabled={loading} onClick={onConfirm}>
          {i18n._('actions.delete')}
        </Button>
      </Group>
    </>
  );
};
